// extracted by mini-css-extract-plugin
export default {"tab":"adefault_tab__wyuBf","active":"adefault_active__uwBSR"};